<template>
	<div class="browser-considerations">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>Browser Differences</h2>
		<div class="flex">
			<div>
			<img src="@/assets/images/browsers-differences.png" alt="kids fighting"/>
			</div>
			<div>
		<ul>
			<li><img src="@/assets/images/logo-generic.png" alt="Generic logo"/><div class="list-content">Resolution is set by audio hardware.</div></li>
			<li><img src="@/assets/images/logo-safari.png" alt="Safari logo"/><div class="list-content">Safari doesn't support resampling.</div></li>
			<li><img src="@/assets/images/logo-safari.png" alt="Safari logo"/><div class="list-content">iOS only allows Safari to record.</div></li>
			<li><img src="@/assets/images/logo-safari.png" alt="Safari logo"/><div class="list-content">Safari will re-ask for recording permission after an idle minute.</div></li>
			<li><img src="@/assets/images/logo-safari.png" alt="Safari logo"/><div class="list-content">The recording volume appears to be a float between -1 and 1 for most browsers. However for Safari it can get up to 4.</div></li>
			<li><img src="@/assets/images/logo-safari.png" alt="Safari logo"/><div class="list-content">Something breaks on every major browser release. (Safari 13!)</div></li>
			<li><img src="@/assets/images/logo-chrome.png" alt="Chrome logo"/><div class="list-content">Chromebook has no <code class="inline">echoCancellation</code>, but supports <code class="inline">ideal</code>. Safari is the opposite.</div></li>
		</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "browser-considerations",
		components: {SpeakerNotes},
		data() {
			return {
				notes: [
					"Just a few of the browser differences.",
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.browser-considerations {
		text-align: center;
		@media screen and (min-width: 490px) {
			.flex {
				display: flex;
				justify-content: space-evenly;
				text-align: left;
				align-items: center;

				& > div {
					max-width: 700px;
				}
			}
		}
		ul {
			list-style: none;
			padding: 0;
			font-size: .9em;

			li {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
				border-bottom: 1px solid $light-divider;
			}
			img {
				height: 1em;
			}
			.list-content {
				margin-left: 20px;
			}
		}
	}
</style>
